import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

const watchEntityKeys = ['publicationSpecialDeadlines']

function usePublicationSpecialDeadlines(options = {}){
  const { entityKey, filters, performHttpRequests } = options
  const {
    publication_id: filterPublicationId,
  } = filters || {}

  const {
    updatedEntities: { publicationSpecialDeadlines: publicationSpecialDeadlinesUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { loading: loadingPublicationSpecialDeadlines } = useReduxAction(
    'publicationSpecialDeadlines',
    'loadPublicationSpecialDeadlines',
    {
      ...defaultRequestOptions.publicationSpecialDeadline,
      ...filters,
      entityKey,
    },
    [filters, performHttpRequests],
    {
      shouldPerformFn: ({ loading }) => performHttpRequests && !loading,
    },
  )

  const publicationSpecialDeadlines = useSelector(reduxState => reduxState.entities.publicationSpecialDeadlines)

  const filteredPublicationSpecialDeadlines = useMemo(() => {
    const filtered = Object.values(publicationSpecialDeadlines).filter((specialDeadline) => {
      const { publication_id } = specialDeadline

      const matchPublication = matchFilterNumber(publication_id, filterPublicationId)

      return matchPublication
    })

    return sortArrayBy(filtered, 'desc', 'publication_edition_id')
  }, [publicationSpecialDeadlinesUpdatedAt, JSON.stringify(filters)])

  const hasFilteredPublicationSpecialDeadlines = !!filteredPublicationSpecialDeadlines.length

  return {
    filteredPublicationSpecialDeadlines,
    hasFilteredPublicationSpecialDeadlines,
    loading: loadingPublicationSpecialDeadlines,
  }
}

export default usePublicationSpecialDeadlines
